import React from 'react';

import { CreateAuthorizedForm, Header } from 'components';
import { ServiceStationOnlyRoute } from 'utils';

export const CreateAuthorizedPdf = () => {
  ServiceStationOnlyRoute();

  return (
    <>
      <Header />
      <CreateAuthorizedForm />
    </>
  );
};
